import AuthLayout from './AuthLayout.component'

export default AuthLayout
